module.exports = __webpack_public_path__ + "img/ignis-gls-plus-rojo-vanadio.9b81a24b.png";